import React, { useEffect, useState } from "react";
import axios from "axios";

const branchAxios = axios.create({ baseURL: "https://api2.branch.io" });

export const useReferral = (id?: number) => {
  const [deepLinkLoading, setDeepLinkLoading] = useState(false);

  const [deepLink, setDeepLink] = useState("");

  useEffect(() => {
    if (id) {
      setDeepLinkLoading(true);
      branchAxios
        .post("/v1/url", {
          branch_key: process.env.REACT_APP_BRANCH_KEY,
          feature: "referrals",
          data: {
            referringUserID: String(id),
            $canonical_url: `gadder://otherProfile/${id}`,
          },
        })
        .then(({ data: { url } }) => {
          setDeepLink(url);
        })
        .catch((e) => {
          console.log("Branch error", e);
        })
        .finally(() => setDeepLinkLoading(false));
    }
  }, [id]);

  return [deepLinkLoading, deepLink];
};
